import React, { useContext, useEffect } from 'react'
import { AppContext } from '../App'

function Letter({ letterPos, attemptVal }) {
	const { 
		board, 
		correctWord, 
		currAttempt, 
		correctLetters,
        setCorrectLetters,
        almostLetters,
        setAlmostLetters,
        disabledLetters,
        setDisabledLetters
     	} = useContext(AppContext);
	const letter = board[attemptVal][letterPos];
	const correct = correctWord[4-letterPos] === letter
	const almost = !correct && letter !== "" && correctWord.includes(letter)

	const letterState= currAttempt.attempt > attemptVal && 
	(correct ? "correct" : almost ? "almost" : "error");

	useEffect(() => {
		if (letter !== "" && correct) {
			setCorrectLetters((prev) => [...prev, letter])
		}
		else if (letter !== "" && almost) {
			setAlmostLetters((prev) => [...prev, letter])
		}
		else if (letter !== "" && !correct && !almost) {
			setDisabledLetters((prev) => [...prev, letter])
		}
		
		
	}, [currAttempt.attempt])

	return(
		<div className="letter" id={letterState}>
			{""}
			{letter}
		</div>
	)
}

export default Letter